import { Course } from 'types/course';
import FlexContainer from 'components/common/FlexContainer';
import { Spin } from 'antd';
import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';
import useTranslation from 'hooks/use-translation';

export const Container = styled(FlexContainer)({
  margin: '0px 12% 80px',
  gap: 32,
  [mobileMediaQuery]: {
    margin: '0px 0px 80px',
    gap: 40,
  },
});

export const Header = styled.span({
  fontSize: fontStyles.sizes.xl,
  [mobileMediaQuery]: {
    margin: '0px 20px',
  },
});

type Props = {
  courses: Course[];
};

export function CreditAvailabilitySection(props: Props): JSX.Element {
  const { courses } = props;
  const translation = useTranslation();

  if (!translation) {
    return <Spin />;
  }

  return (
    <CreditAvailabilityContainer gap={24}>
      <FlexContainer gap={16}>
        <Heading className='credit-availability-heading'>Credit availability</Heading>
        <SubHeading>
          This credit decision may be available in the following {translation.courseTerminology.plural}:
        </SubHeading>
      </FlexContainer>
      <FlexContainer gap={12}>
        {courses.map((course) => {
          if (!course.url) {
            return <span>{course.name}</span>;
          }
          return (
            <a key={course.ID} href={course.url} target='_blank' rel='noopener noreferrer'>
              <FlexContainer gap={4} flexDirection='row' alignItems='center'>
                <span>View {course.name}</span>
                <ColoredImage
                  className='external-link-image'
                  src={`./config/icons/${translation.common.icons.externalLink.src}`}
                  alt=''
                  width={16}
                  height={16}
                />
              </FlexContainer>
            </a>
          );
        })}
      </FlexContainer>
    </CreditAvailabilityContainer>
  );
}

const CreditAvailabilityContainer = styled(FlexContainer)({
  gap: 24,
  [mobileMediaQuery]: {
    margin: '0px 20px',
  },
});

const Heading = styled.span({
  color: fontStyles.colors.tertiary,
});

const SubHeading = styled.span({
  lineHeight: '20px',
});

const ColoredImage = styled.img({
  filter: 'invert(14%) sepia(92%) saturate(5314%) hue-rotate(267deg) brightness(85%) contrast(91%)',
});
